import { motion } from 'framer-motion';

const Loader = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
      }}
    >
      <motion.div
        style={{ position: 'relative' }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div
          style={{
            width: '64px',
            height: '64px',
            border: '4px solid #E9D5FF', // Tailwind's purple-200
            borderTopColor: '#7C3AED', // Tailwind's purple-600
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        ></div>

        <motion.div
          style={{
            position: 'absolute',
            inset: 0,
            width: '64px',
            height: '64px',
            border: '4px solid transparent',
            borderTopColor: '#C084FC', // Tailwind's purple-400
            borderRadius: '50%',
            animation: 'spinReverse 1.5s linear infinite',
          }}
        />
      </motion.div>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          @keyframes spinReverse {
            to { transform: rotate(-360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
